import * as FileDownloadService from '../../utils/macros/file';
import { isJSONParsableObject, replaceVariables } from './variables';

const macroStrategies: Record<
  number,
  (state: TicketState, action: MacroAction,
    props: {
      organizationId: number,
      variablesToPlaceholders?: (state: TicketState) => Record<string, string>,
      techinicalTeamList?: Array<any>,
      organizationFieldList?: Array<any>,
      getUsersById: (id: number) => any,
      getOrganizationFieldById?: (id: number) => Promise<any>,
      getOrganizationCategoryById: (id: number) => any,
      getDefaultEmployeeHourValue: (id: number) => any,
      getDefaultActionById: (id: number) => any,
      changeValuesStatusOne?: () => Promise<void>,
      changeValuesStatusTwo?: (value: any) => void,
      changeTechinicalTeam?: (id: number) => Promise<void>,
      changeDefaultActionId?: (value: any) => void,
      changeOrganizationCategoryId?: (value: any, text: string) => Promise<void>,
      setActionDescription?: (item: any) => void,
      setTitle?: (item: any) => void,
    }) => Promise<TicketState>
> = {
  // Definir prioridade como
  1: async (state, action) => {
    return {
      ...state,
      called: {
        ...state?.called,
        priorityid: action.sourceentityid || null,
      }
    }
  },

  // Definir tipo como
  2: async (state, action) => ({
    ...state,
    called: {
      ...state.called,
      type: action.sourceentityid || null,
    }
  }),

  // Definir status como
  3: async (state, action, { changeValuesStatusOne, changeValuesStatusTwo }) => {
    changeValuesStatusOne && await changeValuesStatusOne();
    changeValuesStatusTwo && changeValuesStatusTwo(action?.sourceentityid || null);

    return {
      ...state,
      called: {
        ...state.called,
        status: action.sourceentityid || null,
      }
    }
  },

  // Adicionar acompanhamento
  4: async (state, action, { setActionDescription, variablesToPlaceholders }) => {
    const acompanhamento: any = action?.sourceentityvalue && action?.sourceentityvalue != "" ? action?.sourceentityvalue : null;
    const acompanhamentoParse: any = action?.sourceentityvalue && isJSONParsableObject(action?.sourceentityvalue) ? JSON.parse(action?.sourceentityvalue) : {};

    const text = acompanhamentoParse?.text ? acompanhamentoParse?.text : acompanhamento ? acompanhamento : "";
    const privacy = acompanhamentoParse?.privacy != null ? String(acompanhamentoParse?.privacy || false) : null;

    const actionDescription = replaceVariables(text, variablesToPlaceholders(state));

    setActionDescription?.(actionDescription);

    if (privacy) {
      return {
        ...state,
        action: {
          ...state.action,
          privacy,
        }
      };
    } else {
      return null;
    }
  },

  // Atribuir Agente
  6: async (state, action, { organizationId, getUsersById, getDefaultEmployeeHourValue }) => {
    const user = getUsersById ? await getUsersById(Number(action.sourceentityid) || 0) : null;
    await getDefaultEmployeeHourValue?.(user.id);

    return {
      ...state,
      called: {
        ...state.called,
        assignedUser: user || null,
      }
    }
  },

  // Atribuir Observador
  7: async (state, action, { organizationId, getUsersById }) => {
    const user = getUsersById ? await getUsersById(Number(action.sourceentityid) || 0) : null;

    return {
      ...state,
      called: {
        ...state.called,
        observantUser: user || null,
      }
    }
  },

  // Atribuir Time
  8: async (state, action, { organizationId, techinicalTeamList, changeTechinicalTeam }) => {
    const newTeamId = Number(action.sourceentityid) || 0;

    const team = techinicalTeamList?.find((team: any) => team.id == newTeamId);

    await changeTechinicalTeam?.(newTeamId);

    return {
      ...state,
      called: {
        ...state.called,
        techinicalteam: team || null,
      }
    }
  },

  // Adicionar Ação Padrão
  9: async (state, action, { getDefaultActionById, changeDefaultActionId }) => {
    const defaultAction = getDefaultActionById ? await getDefaultActionById(action.sourceentityid || 0) : null;

    defaultAction.Name = defaultAction?.text || "";
    defaultAction.name = defaultAction?.title || "";

    changeDefaultActionId?.(defaultAction);

    return {
      ...state,
      defaultActionId: defaultAction || 0,
    };
  },

  // Adicionar tag
  13: async (state, action) => {
    const helpState: any = { ...state };
    const currentTags = helpState["tags"] || [];
    const tags = action.sourceentityvalue?.split(",")?.filter((ac) => ac) ?? [];

    return {
      ...state,
      tags: Array.from(new Set([...currentTags, ...tags]))
    }
  },

  // Definir valor campo personalizado
  14: async (state, action, { organizationId, getOrganizationFieldById, organizationFieldList }) => {

    const ofieldId = Number(action.sourceentityid) || 0;
    const organizationField = getOrganizationFieldById ? await getOrganizationFieldById(ofieldId) : null;

    const fieldOrganizationId = organizationField?.organizationid || null;
    const organizationFieldType = organizationField?.organizationfieldtype;

    if (fieldOrganizationId && organizationId != fieldOrganizationId) {
      return {
        ...state,
        error: {
          success: false,
          actions: [
            ...(state?.error?.actions ?? []),
            "Definir valor campo personalizado"
          ]
        }
      };
    }

    const organizationfieldoptionsvalues = organizationFieldList?.find((f: any) => f.organizationfieldtype == organizationFieldType)?.organizationfieldoptionsvalues || [];

    const stateName = `ofield-${ofieldId}`;
    let value = null;

    const valueByType: Record<number, () => any> = {
      1: () => organizationField.maxlength ? action.sourceentityvalue || "".slice(0, organizationField.maxlength) : action.sourceentityvalue || "", //TextField
      2: () => {
        let _sourceentityvalue = null;

        if (!action.sourceentityvalue) return null;

        _sourceentityvalue = organizationfieldoptionsvalues?.find((opt: any) => Number(opt.id) == Number(action.sourceentityvalue))?.name || action.sourceentityvalue;

        return _sourceentityvalue + '\n' + action.sourceentityvalue;
      }, //RadioGroup
      3: () => (action.sourceentityvalue || null) == "true", //SimpleCheckBox
      4: () => {
        if (!action.sourceentityvalue) return null;

        return organizationfieldoptionsvalues?.find((opt: any) => Number(opt.id) == Number(action.sourceentityvalue));
      }, //SimpleAutoComplete
    };

    if (valueByType[organizationFieldType]) {
      value = valueByType[organizationFieldType]();
    }

    return {
      ...state,
      customMacroOrganizationId: fieldOrganizationId,
      called: {
        ...state.called,
        [stateName]: value,
      }
    }
  },

  // Definir categoria como
  15: async (state, action, { organizationId, getOrganizationCategoryById, changeOrganizationCategoryId }) => {
    if (action.sourceentityid && organizationId != action.sourceentityid) {
      return {
        ...state,
        error: {
          success: false,
          actions: [
            ...(state?.error?.actions ?? []),
            "Definir categoria"
          ]
        }
      };
    }

    const category = getOrganizationCategoryById ? await getOrganizationCategoryById(Number(action.sourceentityvalue) || 0) : null;

    await changeOrganizationCategoryId?.(category, "")

    return null;
  },

  // Definir texto do título
  16: async (state, action, { variablesToPlaceholders, setTitle }) => {
    const title = replaceVariables(action.sourceentityvalue || "", variablesToPlaceholders(state));

    setTitle?.(title);

    return null;
  },

  // Definir texto da descrição
  17: async (state, action, { variablesToPlaceholders }) => {
    const description = replaceVariables(action.sourceentityvalue || "", variablesToPlaceholders(state));

    return {
      ...state,
      called: {
        ...state.called,
        description
      }
    }
  },

  // Definir anexos do chamado
  18: async (state, action) => {
    const fileDatas = await FileDownloadService.getDataFiles([action]);

    return {
      ...state,
      files: fileDatas
    }
  },

  // Definir organização
  19: async (state, action) => {
    return null;
  },

  // Define o valor da localização(endereço) do chamado.
  20: async (state, action, { organizationId }) => {
    if (action.sourceentityid && organizationId != action.sourceentityid) {
      return {
        ...state,
        error: {
          success: false,
          actions: [
            ...(state?.error?.actions ?? []),
            "Definir valor da localização"
          ]
        }
      };
    }

    return {
      ...state,
      called: {
        ...state.called,
        addressid: Number(action.sourceentityvalue) || 0,
      }
    }
  },

  // Define o solicitante do chamado.
  21: async (state, action, { organizationId }) => {
    if (action.sourceentityid && organizationId != action.sourceentityid) {
      return {
        ...state,
        error: {
          success: false,
          actions: [
            ...(state?.error?.actions ?? []),
            "Define o solicitante do chamado"
          ]
        }
      };
    }

    return null;
  },
};
export default macroStrategies;